import React, { useCallback, useEffect, useState } from "react";
import wallet from "../../assests/wallet.png";
import { getDashboardData } from "../../redux/services/dashboardSlice";
import { useDispatch, useSelector } from "react-redux";
import { convertUtcToIst } from "../../common/TimeUtils";
import { FiFilter } from "react-icons/fi";
import moment from "moment-timezone";
import DateFilter from "../../common/DateFilter";
import Loader from "../../common/Loader";
import income from "../../assests/incomeImg.png";
import profit from "../../assests/profitImg.png";

const IncomeExpense = () => {
  const dispatch = useDispatch();
  const getIncExpData = useSelector((state) => state?.dashboard?.dashboardData);
  const [toggle, setToggle] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [savedStartDate, setSavedStartDate] = useState("");
  const [savedEndDate, setSavedEndDate] = useState("");
  const handleSaveDate = () => {
    setSavedStartDate(startDate);
    setSavedEndDate(endDate);
    if (handleDateSubmit) {
      handleDateSubmit();
    }
  };
  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    setSavedStartDate("");
    setSavedEndDate("");
    if (handleDateSubmit) {
      handleDateSubmit();
    }
  };
  const walletData = [
    {
      id: 1,
      title: "Total Wallet Entry",
      amount: `₹${getIncExpData?.sec1?.wallet?.totalWalletEntry}`,
    },
    {
      id: 2,
      title: "Amount Used For Contest",
      amount: `₹${getIncExpData?.sec1?.wallet?.amountUsedForContest}`,
    },
    {
      id: 3,
      title: "Amount Unused In Wallet",
      amount: `₹${getIncExpData?.sec1?.wallet?.amountUnusedInWallet}`,
    },
  ];
  const IncomeData = [
    {
      id: 1,
      title: "Earning Form Contest",
      amount: `₹${getIncExpData?.sec2?.income?.amountPaidForContest}`,
    },
    {
      id: 2,
      title: "Amount Used For Course",
      amount: `₹${getIncExpData?.sec2?.income?.courseEarning}`,
    },
    {
      id: 3,
      title: "Amount Used For Workshop",
      amount: `₹${getIncExpData?.sec2?.income?.workshopEarning}`,
    },
  ];
  const expenseData = [
    {
      id: 1,
      title: "Today Prize Distribution ",
      amount: `₹${getIncExpData?.sec3?.expenses?.prizeDistributionAmount}`,
    },
    {
      id: 2,
      title: "Amount Shared To Coaching",
      amount: `₹${getIncExpData?.sec3?.amountShared}`,
    },
    {
      id: 3,
      title: "Referral Shared Coin",
      amount: `₹${getIncExpData?.sec3?.expenses?.referralBonus}`,
    },
  ];
  const totalExpense = getIncExpData?.sec3?.amountShared + getIncExpData?.sec3?.expenses?.prizeDistributionAmount + getIncExpData?.sec3?.expenses?.referralBonus;
  const ProfitData = [
    {
      id: 1,
      title: "TOTAL INCOME",
      amount: `₹${getIncExpData?.sec2?.income?.amountPaidForContest}`,
    },
    {
      id: 2,
      title: "TOTAL EXPENCES",
      amount: `₹${totalExpense}`,
    },
    {
      id: 3,
      title: "TOTAL PROFIT",
      amount: `₹${Number(getIncExpData?.sec2?.income?.amountPaidForContest) - totalExpense}`,
    },
  ];

  const handleDateSubmit = () => {
    let adjustedStartDate = null;
    if (startDate) {
      adjustedStartDate = new Date(startDate);
      adjustedStartDate.setHours(0, 0, 0, 0);
    }

    let adjustedEndDate = null;
    if (endDate) {
      adjustedEndDate = new Date(endDate);
      adjustedEndDate.setHours(23, 59, 59, 999);
    }
    const SDate = adjustedStartDate ? convertUtcToIst(adjustedStartDate) : null;
    const EDate = adjustedEndDate ? convertUtcToIst(adjustedEndDate) : null;
    if (SDate && EDate) {
      setToggle(false);
      getAllDashboardData(SDate, EDate);
      setStartDate(null);
      setEndDate(null);
    } else {
      getAllDashboardData();
    }

    return { SDate, EDate };
  };

  const getAllDashboardData = useCallback(
    async (SDate, EDate) => {
      try {
        const payload = { startDate: SDate, endDate: EDate };
        await dispatch(getDashboardData(payload));
      } catch (error) {}
    },
    [dispatch]
  );

  useEffect(() => {
    getAllDashboardData();
  }, [getAllDashboardData]);

  return (
    <>
      {getIncExpData && Object.keys(getIncExpData).length > 0 ? (
        <div>
          <div className="flex items-end justify-end md:flex-row flex-col-reverse gap-3">
            {savedStartDate && savedEndDate && (
              <button onClick={handleClearDates} className="inline-flex items-center space-x-2 rounded-xl px-2 py-2 text-md text-center text-white bg-primary hover:bg-opacity-90">
                <p className="font-semibold">Clear</p>
              </button>
            )}
            <button onClick={() => setToggle(true)} className="inline-flex items-center space-x-2 rounded-xl px-2 py-2 text-md text-center text-white bg-primary hover:bg-opacity-90">
              <FiFilter className="font-bold text-white w-4 h-4" />
              <p className="font-semibold">Filter</p>
              {savedStartDate && savedEndDate && <p>({`${moment(savedStartDate).format("Do MMMM")} - ${moment(savedEndDate).format("Do MMMM")}`})</p>}
            </button>
          </div>
          <div className="flex justify-center mt-5">
            <div className="bg-card rounded-xl shadow-theme p-6 max-w-md w-full">
              <div className="flex items-center mb-5">
                <div className="p-2 bg-[#CFF7D3] rounded-xl">
                  <img src={wallet} alt="Wallet Icon" className="w-8 h-8 " />
                </div>
                <h2 className="ml-2 font-bold text-[22px]">Wallet</h2>
              </div>
              <ul className="list-disc space-y-3 text-[18px] font-medium">
                {walletData.map((item) => (
                  <li key={item.id} className="flex justify-between">
                    <span>{item.title}</span>
                    <span>{item.amount}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="flex justify-between mt-5 flex-wrap gap-4">
            <div className="bg-card rounded-xl shadow-theme p-6 max-w-md w-full">
              <div className="flex items-center mb-5">
                <div className="p-2 bg-[#CFF7D3] rounded-xl">
                  <img src={income} alt="Wallet Icon" className="w-8 h-8 " />
                </div>
                <h2 className="ml-2 font-bold text-[22px]">Income</h2>
              </div>
              <ul className="list-disc space-y-3 text-[18px] font-medium">
                {IncomeData.map((item) => (
                  <li key={item.id} className="flex justify-between">
                    <span>{item.title}</span>
                    <span>{item.amount}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="bg-card rounded-xl shadow-theme p-6 max-w-md w-full">
              <div className="flex items-center mb-5">
                <div className="p-2 bg-[#CFF7D3] rounded-xl">
                  <img src={wallet} alt="Wallet Icon" className="w-8 h-8 " />
                </div>
                <h2 className="ml-2 font-bold text-[22px]">Expense</h2>
              </div>
              <ul className="list-disc space-y-3 text-[18px] font-medium">
                {expenseData.map((item) => (
                  <li key={item.id} className="flex justify-between">
                    <span>{item.title}</span>
                    <span>{item.amount}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="flex justify-center mt-5">
            <div className="bg-card rounded-xl shadow-theme p-6 max-w-md w-full">
              <div className="flex items-center mb-5">
                <div className="p-2 bg-[#CFF7D3] rounded-xl">
                  <img src={profit} alt="Wallet Icon" className="w-8 h-8 " />
                </div>
                <h2 className="ml-2 font-bold text-[22px]">Profit</h2>
              </div>
              <ul className="list-disc space-y-3 text-[18px] font-medium">
                {ProfitData.map((item, index) => (
                  <>
                    <li key={index} className="flex justify-between">
                      <span>{item.title}</span>
                      <span>{item.amount}</span>
                    </li>
                    {index === 1 && <hr className="border-t border-border my-2" />}
                  </>
                ))}
              </ul>
            </div>
          </div>
          {toggle && (
            <DateFilter
              setToggle={setToggle}
              toggle={toggle}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              handleDateSubmit={handleSaveDate}
              startDate={startDate}
              endDate={endDate}
              onClose={() => {
                setToggle(false);
                handleClearDates();
              }}
            />
          )}
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default IncomeExpense;
